<template>
  <div class="list-poi flex justify-between items-center">
    <div class="flex gap-16 grow items-center" v-touch:tap="onPOIClick()">
      <img :src="poi.getIconUrl()" class="w-56 max-h-32 object-contain hidden md:block" />
      <label class="poi-name" v-html="poi.getName(language)"></label>
    </div>
    <div class="flex justify-end gap-6 items-center" v-touch:tap="showPath()">
      <button
        class="btn poi-floor flex items-center gap-2 leading-normal"
        v-if="poi.getFloor()"
      >
        <WFIcon name="floor" class="w-18 h-18"></WFIcon>
        <WFTranslate
          k="floor"
          class="pt-2 leading-normal text-16"
          :params="[poi.getFloor().getName(language)]"
        ></WFTranslate>
      </button>
      <button
        class="btn poi-floor flex items-center gap-2 leading-normal bg-neutral p-4 px-8 text-12 rounded-md hidden md:block"
        v-if="poi.getFloor()"
      >
        <WFIcon name="path" class="w-18 h-18"></WFIcon>
        <WFTranslate
          k="show_path"
          class="pt-2 leading-normal text-16"
        ></WFTranslate>
      </button>
      <!--label class="bg-neutral p-4 px-6 text-12 pt-6 rounded-md">
            {{ getFirstGroup(poi) }}
        </label-->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { WFIcon, WFTranslate } from "@3dwayfinder/wayfinder-vue-components";

export default {
  components: {
    WFTranslate,
    WFIcon,
  },
  computed: {
    ...mapState("wf", ["language"]),
  },
  props: {
    poi: {
      default: null,
      type: Object,
    },
  },
  methods: {
    onPOIClick() {
      return () => {
        this.$emit("onPOIClick", this.poi);
      };
    },
    getFirstGroup(poi) {
      if (typeof poi === "object") {
        return poi.getGroupNames().length > 0 ? poi.getGroupNames()[0] : "";
      }

      return "";
    },
    showPath() {
      return () => {
        if (this.poi) {
          this.$wayfinder.showPath(this.poi.getNode(), this.poi);
        }
      };
    },
    isImage () {
            if(this.poi) {
                if (this.poi.getIconUrl() != null && this.poi.getIconUrl().length > 0) return "image-logo";
            }
			
			return "image-none";
		},
  },
};
</script>

<style lang="postcss">
.list-poi {
  .wf-poi {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 1.6rem;
  }

  .wf-poi-image {
    width: 5.6rem;
    height: 3.2rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .group-label {
    background-color: var(--th-neutral);
  }

  .poi-name {
    text-align: left;
  }

  .image-none {
      display: none;
  }
}
</style>
